import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgCaretLeft = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.781 19.22a.75.75 0 1 1-1.061 1.061l-7.5-7.5a.75.75 0 0 1 0-1.061l7.5-7.5a.75.75 0 1 1 1.061 1.061l-6.97 6.97z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCaretLeft);
export default ForwardRef;
